import { store } from '../store/store';
import { HttpRequest } from '../utils';

const httpRequest = new HttpRequest(store);

export const list = async (data: {
  page: number;
  limit: number;
  query?: string;
  source: string;
}) => {
  const res = await httpRequest.get('/api/car_brand', data);
  return res;
};

export const create = async (data: { name: string; source: string; sourceUrl: string }) => {
  const res = await httpRequest.post('/api/car_brand', data);
  return res;
};

export const get = async (id: string) => {
  const res = await httpRequest.get(`/api/car_brand/${id}/detail`);
  return res;
};

export const select = async (payload: any) => {
  const res = await httpRequest.get(`/api/car_brand/select`, {
    ...payload,
    limit: 100,
  });
  return res;
};

export const remove = async (id: string) => {
  const res = await httpRequest.del(`/api/car_brand/${id}`);
  return res;
};

export const update = async (
  id: string,
  data: {
    id: string;
    name: string;
    nameEng: string;
  }
) => {
  const res = await httpRequest.put(`/api/car_brand/${id}/update`, data);
  return res;
};
